import { StyleSheet, Platform, Dimensions } from 'react-native'
import { JDDevice } from '@jdreact/jdreact-core-lib'
const { width, height } = Dimensions.get('window');

// 计算元素宽度 : tabItemWith = ( 屏幕宽度 - 左右边距 - tab 间隔距离 ) / 6
const getMapNavItemWidth = (width - JDDevice.getRpx(108) - JDDevice.getRpx(80)) / 6 
 
const styles = StyleSheet.create({
  mapAndResourceBox: {
    paddingHorizontal: JDDevice.getRpx(30),
    paddingBottom: JDDevice.getRpx(36),
  },
  map: {
    height: JDDevice.getRpx(350),
    borderRadius: JDDevice.getRpx(20),  // 添加圆角
    overflow: 'hidden'
  },
  // 图标样式
  marker:{
    width: JDDevice.getRpx(32),
    height: JDDevice.getRpx(32),
  },
  textMarkerBoxAndroid: {
    backgroundColor: "#fff",
    width: JDDevice.getRpx(420),
    height: JDDevice.getRpx(150),
    paddingVertical: JDDevice.getRpx(24),
    paddingHorizontal: JDDevice.getRpx(30),
    borderRadius: JDDevice.getRpx(12),
  },
  textMarkerContanierAndroid: {
    width: JDDevice.getRpx(420),
    paddingVertical: JDDevice.getRpx(24),
    paddingHorizontal: JDDevice.getRpx(30),
    backgroundColor: '#FFF',
    borderRadius: JDDevice.getRpx(12),
    ...Platform.select({ // 不同的平台执行不同的样式
      ios: {
        shadowColor: '#000',
        shadowOffset: { h: 0, w: JDDevice.getRpx(2) }, // ios设置阴影
        shadowRadius: JDDevice.getRpx(8),
        shadowOpacity: 0.12
      },
      android: {
        elevation: 4 // 设置Android机上的阴影
      }
    })
  },
  textMarkerArrowAndroid: {
    width: 0,
    height: 0,
    borderLeftColor: "transparent",
    borderRightColor: "transparent",
    borderBottomColor: "transparent",
    borderLeftWidth: JDDevice.getRpx(12),
    borderRightWidth: JDDevice.getRpx(12),
    borderTopWidth: JDDevice.getRpx(16),
    borderStyle: 'solid',
    borderTopColor: "#fff"
  },
  markerTitleAndroid: {
    // fontSize: JDDevice.getRpx(32),
    // color: '#424854',
    // lineHeight: JDDevice.getRpx(45),
    // marginBottom: JDDevice.getRpx(4)，
    // marginLeft: 46,
    // marginTop: 33,
    fontWeight: 'bold',
    // paddingBottom: 50,
  },
  markerDescriptionAndroid: {
    fontSize: JDDevice.getRpx(28),
    color: '#848689',
    lineHeight: JDDevice.getRpx(40)
  },
  // 弹窗内容
  textMarkerBox: {
    position: "relative",
    top: -JDDevice.getRpx(8),
    left: JDDevice.getRpx(8),
  },
  textMarkerContanier: {
    position: "absolute",
    bottom: JDDevice.getRpx(14),
    left: -JDDevice.getRpx(175),
    width: JDDevice.getRpx(350),
    paddingVertical: JDDevice.getRpx(12),
    paddingHorizontal: JDDevice.getRpx(14),
    backgroundColor: '#FFF',
    borderRadius: JDDevice.getRpx(12),
    ...Platform.select({ // 不同的平台执行不同的样式
      ios: {
        shadowColor: '#000',
        shadowOffset: { h: 0, w: JDDevice.getRpx(2) }, // ios设置阴影
        shadowRadius: JDDevice.getRpx(8),
        shadowOpacity: 0.12
      },
      android: {
        elevation: 4 // 设置Android机上的阴影
      }
    })
  },
  markerTitle: {
    width: '100%',
    textAlign: 'center',
    justifyContent: 'center',
    fontSize: JDDevice.getRpx(28),
    fontWeight: 'bold',
    color: '#000',
    lineHeight: JDDevice.getRpx(40),
  },
  markerDescription: {
    width: '100%',
    textAlign: 'center',
    justifyContent: 'center',
    fontSize: JDDevice.getRpx(22),
    color: '#888',
    lineHeight: JDDevice.getRpx(30)
  },
  textMarkerArrow: {
    width: 0,
    height: 0,
    borderLeftColor: "transparent",
    borderRightColor: "transparent",
    borderBottomColor: "transparent",
    borderLeftWidth: JDDevice.getRpx(12),
    borderRightWidth: JDDevice.getRpx(12),
    borderTopWidth: JDDevice.getRpx(16),
    borderStyle: 'solid',
    borderTopColor: "#fff"
  },

  // Tab 栏
  mapResourceBox: {
    paddingTop: JDDevice.getRpx(28),  // 
  },
  mapNavList: {
    justifyContent: 'space-between',
    flexWrap: 'nowrap',
    flexDirection: 'row'
  },
  mapNavItem: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
    // width: JDDevice.getRpx(94),
    width:getMapNavItemWidth ||JDDevice.getRpx(94),
    height: JDDevice.getRpx(57),
    color: 'rgba(85,85,85,1)',
    backgroundColor: 'rgba(246, 246, 246, 1)',
    borderRadius: JDDevice.getRpx(29),
    overflow: 'hidden',
  },
  // 资源列表
  // 空状态
  pointListEmpey: {
    width: '100%',
    height: JDDevice.getRpx(228),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  pointListLoadingIcon: {
		width: JDDevice.getRpx(60)
	},
  pointListEmpeyIcon: {
    width: JDDevice.getRpx(154),
    height: JDDevice.getRpx(80)
  },
  pointListEmpeyMessage: {
    color: '#a6aab0',
    fontSize: JDDevice.getRpx(28),
    paddingTop: JDDevice.getRpx(16),
  },
  mapResourceList: {
    justifyContent: 'space-between',
    flexWrap: 'nowrap',
    paddingTop: JDDevice.getRpx(20)
  },
  mapResourceItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: JDDevice.getRpx(36),
    lineHeight: JDDevice.getRpx(36),
    marginBottom: JDDevice.getRpx(16),
    overflow: 'hidden',
  },
  mapResourceName: {
    width: JDDevice.getRpx(444),
    marginLeft: JDDevice.getRpx(12),
    overflow: 'hidden',
    fontSize: JDDevice.getRpx(28)
  },
  mapResourceImg: {
    width: JDDevice.getRpx(36),
    height: JDDevice.getRpx(36),
  },
  mapResourceDist: {
    marginLeft: JDDevice.getRpx(33),
    flexShrink: 0,
    width: JDDevice.getRpx(120),
    color: 'rgba(153,153,153,1)',
    fontSize: JDDevice.getRpx(24),
  }
});

export default styles
